<template>
    <div class="smallStempels text-center pointer" @click="$ebus.$emit('goto',{name:'Stempelkarte'})">
        <StempelAnzahl class="mb-2"></StempelAnzahl>
        <!--        <div>DEBUG xPunkte: {{xPunkte}}</div>-->
        <div v-if="$store.getters.loggedIn">
            <div v-if="stempelCounter < 10">
                Durch diese Bestellung sammelst du
                <!--             <b>{{xPunkte}} Stempel-Punkte</b>-->
                <span> <b>{{moreStempel}} Stempel</b></span>
            </div>
        </div>
        <div v-else>
            <h4>Registriere dich kostenlos, um Stempel zu sammeln</h4>
        </div>

        <!--        <div>Bei {{xEuro}} Euro</div>-->
    </div>
</template>

<script>
    import store from '../store/store'
    import StempelAnzahl from "../stempelkarte/StempelAnzahl";

    export default {
        name: "SmallStempelkarte",
        components: {StempelAnzahl},
        computed: {
            punktestand() {
                return this.$store.getters.stempelkarte.punktestand;
            },
            stempelCounter() {
                let p = this.punktestand;
                let r = 0;
                let t = Math.trunc(p / 10);
                if (t > 1) {
                    r = t;
                }
                if (r > 10) {
                    r = 10;
                }
                return r;
            },
            xPunkte() {
                let sum = store.getters.payerSum;
                let p = Math.trunc(sum);
                return p;
            },
            moreStempel() {
                let stempelBefore = this.stempelCounter;

                let p = this.punktestand;
                let x = this.xPunkte;
                let r = p + x;
                // if (p > 0) {
                //     r = 1;
                // }
                // if (p > 1) {
                //     r = p;
                // }
                if (r > 100) {
                    r = 100;
                }

                let stempelAfter = Math.trunc(r / 10);
                let diff = stempelAfter - stempelBefore;

                return diff;
            },
        },

    }
</script>

<style scoped lang="scss">
    @import '../styles/base';
    @import '../styles/stempel';

    .smallStempels {
        display: inline-block;
        padding: 20px;
        background-color: $stempelBgColor;
        border: 1px solid $stempelBorderColor;
        border-radius: $box-border-radius;
        color: $stempelTextColor;

        h2, h3, h4 {
            color: $stempelTextColor;
        }
    }

    .smallStempels ::v-deep * {
        h2, h3, h4 {
            color: $stempelTextColor;
        }
    }
</style>